
<div class="dm7Select">
    <div class="select-side">
        <i class="bi bi-caret-down-fill"></i>
        
    </div>
    <ng-select
            [items]="configMultiSelect"
            [multiple]="true"
            [closeOnSelect]="false"
            bindValue="element.value"
            bindLabel="element.label"
            [(ngModel)]="selectedItemsArray"
            (ngModelChange)="selectedItems.emit(selectedItemsArray)">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.element.label}}
            </ng-template>
        </ng-select>
</div>